module.exports = __webpack_public_path__ + "img/Swiss frank Icon - white.6d2184e3.svg";